module.exports = __webpack_public_path__ + "img/ep_service.2cd35729.svg";